module.exports = __webpack_public_path__ + "5c7c76e58cedf78c290a7ab5f2e3aa08.svg";